export default __webpack_public_path__ + "images/Image14.e02a7150.png";